import { LocalizationKeys } from '../constants/localization-keys';

export const locationTargetsOptionKeys = {
  everywhere: 'everywhere',
  specific: 'specific',
  bundleOrDefaultMarket: 'bundle',
};

export const getLocationsString = (i18n, settings, isAdGroupLevel = false, bidStrategyType, hideBid = false) => {
  if (settings == null) {
    return i18n.getString(_TL_('Targeting everywhere.'));
  }

  const {
    targetOption,
    currentLocations = [],
  } = settings;

  let isTargetEverywhere = targetOption === locationTargetsOptionKeys.everywhere;
  if (isAdGroupLevel) {
    isTargetEverywhere = currentLocations.length === 0;
  }

  if (isTargetEverywhere) {
    return i18n.getString(_TL_('Targeting everywhere.'));
  }

  let details = '';
  let includedLocations = currentLocations.filter(x => x.SelectionStatus === 'Included');
  const excludedLocations = currentLocations.filter(x => x.SelectionStatus === 'Excluded');
  if (bidStrategyType === 'Commission') {
    includedLocations = [];
  }
  if (includedLocations.length) {
    details += `${i18n.getString(_TL_('Included locations: '))}`;
    includedLocations.forEach((target, index) => {
      details += target.location;
      if (!hideBid) {
        details += `: ${i18n.getString(LocalizationKeys[target.bidAdjustmentDropdown])}`;
        details += `: ${target.bidAdjustmentInput}%`;
      }
      if (index < includedLocations.length - 1) {
        details += ', ';
      }
    });
  }
  if (excludedLocations.length) {
    if (includedLocations.length) {
      details += ', ';
    }
    details += `${i18n.getString(_TL_('Excluded locations: '))}`;
    excludedLocations.forEach((target, index) => {
      details += target.location;
      if (index < excludedLocations.length - 1) {
        details += ', ';
      }
    });
  }
  return details;
};

export const getLocationTargetTitleDetails = (i18n, location, isAdGroupLevel, bidStrategyType, hideBid = false) => {
  if (!location) return '';
  const {
    parentLevelSettings,
    currentLevelSettings,
    useParentLevel,
  } = location;

  if (useParentLevel) {
    if (isAdGroupLevel) {
      return getLocationsString(i18n, parentLevelSettings, isAdGroupLevel, bidStrategyType, hideBid);
    }
    return i18n.getString(_TL_('Targeting everywhere.'));
  }

  return getLocationsString(i18n, currentLevelSettings, isAdGroupLevel, bidStrategyType, hideBid);
};

export const mergeLocations = (includedLocations, excludedLocations, targetedLocations) => {
  let conflictingCount = 0;
  let duplicateCount = 0;

  // Create Sets of existing location IDs for efficient lookup
  const includedLocationIds = new Set(includedLocations.map(loc => loc.location.Id));
  const excludedLocationIds = new Set(excludedLocations.map(loc => loc.location.Id));

  const newIncludedLocations = [];
  const newExcludedLocations = [];

  // Process targeted included locations
  targetedLocations.includedLocations.forEach((loc) => {
    const locId = loc.location.Id;
    if (excludedLocationIds.has(locId)) {
      conflictingCount += 1;
    } else if (includedLocationIds.has(locId)) {
      duplicateCount += 1;
    } else {
      newIncludedLocations.push(loc);
    }
  });

  // Process targeted excluded locations
  targetedLocations.excludedLocations.forEach((loc) => {
    const locId = loc.location.Id;
    if (includedLocationIds.has(locId)) {
      conflictingCount += 1;
    } else if (excludedLocationIds.has(locId)) {
      duplicateCount += 1;
    } else {
      newExcludedLocations.push(loc);
    }
  });

  return {
    includedLocations: [...includedLocations, ...newIncludedLocations],
    excludedLocations: [...excludedLocations, ...newExcludedLocations],
    conflictingCount,
    duplicateCount,
  };
};
